<template>
    <div class="FormContacts">
        <b class="text-dark">Reach out to us</b>
        <div class="single-contact-detail my-3">
            <div class="row no-gutters">
                <div class="col-12 col-md-4">
                    <div class="single-contact text-center">
                        <div class="single-contact-icon rounded-50 mx-auto mb-2">
                            <i class="fa fa-map-marker"></i>
                        </div>
                        <div class="single-contact-txt">
                            <span>Forward In Faith Ministries Australia. <br /> 5-7 Swettenham Rd, Minto NSW 2566</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="single-contact text-center">
                        <div class="single-contact-icon rounded-50 mx-auto mb-2">
                            <i class="fa fa-phone"></i>
                        </div>
                        <div class="single-contact-txt">
                            <span class="d-block"><a href="tel:+61 (2) 9602 1600" class="text-light">+61 (2) 9602 1600</a></span>
                            <span class="d-block"><a href="tel:+61 (2) 9602 1600" class="text-light">+61 (2) 9602 1600</a></span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="single-contact text-center">
                        <div class="single-contact-icon rounded-50 mx-auto mb-2">
                            <i class="fa fa-envelope"></i>
                        </div>
                        <div class="single-contact-txt">
                            <span class="d-block"><a href="mailto:enquiry@fifmi.org.au" class="text-light">enquiry@fifmi.org.au</a></span>
                            <span class="d-block"><a href="mailto:www.fifmi.org" class="text-light">www.fifmi.org</a></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-comment-form">
            <form>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Name :">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Email :">
                        </div>
                    </div>
                    <div class="col-12 col-md-12">
                        <div class="form-group">
                            <textarea class="form-control" placeholder="Message :"></textarea>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <button type="submit" class="btn btn-primary btn-lg rounded-0">Post Message</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
